'use client'

import { useRef } from 'react'
import { Loader2 } from 'lucide-react'
import ProductCard from '../product/ProductCard'
import { useInfiniteProducts } from '@/hooks/use-infinite-products'
import { useInfiniteScroll } from '@/hooks/use-infinite-scroll'

export default function AllProducts({ vendor, title, description, session }: { vendor: any, wishlist?: any, title?: string, description?: string, session?: any }) {
  const loadMoreRef = useRef<HTMLDivElement>(null)
  const { products, isLoading, isLoadingMore, metadata, loadMore, hasMore, pendingCount } = useInfiniteProducts({
    vendorId: vendor?.id,
    limit: 20,
    initialFilters: {},
    session,
  })

  useInfiniteScroll({
    targetRef: loadMoreRef,
    onLoadMore: loadMore,
    enabled: hasMore && !isLoading && !isLoadingMore,
  })

  return (
    <section className="bg-cream py-4 sm:py-8">
      <div className="mx-auto max-w-[1280px] px-6 lg:px-10">
        <div className="mb-8">
          <div className="text-[11px] tracking-[0.2em] uppercase font-semibold text-foreground/55">Бүх бараа</div>
          <h2
            className="mt-2 font-bold font-gilroy text-foreground leading-[0.96] tracking-[-0.025em]"
            style={{ fontSize: 'clamp(34px,4vw,52px)' }}
          >
            {title || 'Бүх бүтээгдэхүүн.'}
          </h2>
          {!isLoading && metadata?.total > 0 && (
            <div className="mt-3 text-[14px] text-foreground/55">{metadata.total} бүтээгдэхүүн</div>
          )}
          {description && (
            <p className="mt-3 text-[15px] text-foreground/70 max-w-xl">{description}</p>
          )}
        </div>
        {isLoading ? (
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 lg:gap-5">
            {Array.from({ length: 10 }).map((_, i) => (
              <div key={i} className="aspect-square rounded-2xl bg-foreground/5 animate-pulse" />
            ))}
          </div>
        ) : products.length > 0 ? (
          <>
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 lg:gap-5">
              {products.map((p: any) => (
                <ProductCard key={p.customId || p.id} product={p} vendor={vendor} />
              ))}
              {Array.from({ length: pendingCount }).map((_, i) => (
                <div key={`pending-${i}`} ref={i === 0 ? loadMoreRef : undefined}>
                  <div className="aspect-square rounded-2xl bg-foreground/5" />
                  <div className="pt-4 flex flex-col gap-2">
                    <div className="h-4 w-1/3 rounded bg-foreground/5" />
                    <div className="h-5 w-3/4 rounded bg-foreground/5" />
                    <div className="h-5 w-1/2 rounded bg-foreground/5" />
                  </div>
                </div>
              ))}
            </div>
            {hasMore && (
              <div ref={pendingCount === 0 ? loadMoreRef : null} className="flex justify-center py-10">
                {isLoadingMore && <Loader2 className="size-5 animate-spin text-foreground/40" />}
              </div>
            )}
          </>
        ) : (
          <div className="text-center text-foreground/55 py-12">Бүтээгдэхүүн олдсонгүй</div>
        )}
      </div>
    </section>
  )
}
